<template>
  <div>
    <SkeletonLoaderTitleUpdate v-show="showSkeleton" />

    <div class="ma-4" v-show="!showSkeleton">
      <div class="text-h4 mb-4">Atualizar TAG - {{ description }}</div>
    </div>
    <div v-if="canRender">
      <CadastroTag edicao="true" :_id="_id" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import SkeletonLoaderTitleUpdate from '@/componentes/SkeletonLoaderTitleUpdate'

import tagsStore from '../_store'

import CadastroTag from './CadastroTag'

export default {
  props: {
    _id: String,
  },

  components: { SkeletonLoaderTitleUpdate, CadastroTag },

  data: () => ({
    description: '',
    showSkeleton: false,
    canRender: false,
  }),

  computed: {
    ...mapGetters('atualizarTagModulePABXStore', ['getSpecificTag']),
  },

  async created() {
    this.showSkeleton = true

    registerVuexModule(this.$store, 'atualizarTagModulePABXStore', tagsStore)

    await this.listarTagEspecifica(this._id)
    this.description = this.getSpecificTag.description

    this.showSkeleton = false
    this.canRender = true
  },

  methods: {
    ...mapActions('atualizarTagModulePABXStore', ['listarTagEspecifica']),
  },
}
</script>
